export enum Region {
    AU = 'AU',
    NZ = 'NZ',
}
